export const clientShouldWaitForAgent = (status) =>
  Boolean(status && typeof status === "object");
